"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.TextArea = void 0;

var _styledComponents = _interopRequireDefault(require("styled-components"));

var _TextInput = require("../TextInput/TextInput.style");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function _templateObject() {
  var data = _taggedTemplateLiteral(["\n  resize: none;\n  outline: none;\n  border: 1px solid ", ";\n  border-radius: 3px;\n  background-color: #ffffff;\n  height: 102px;\n  font-size: 13px;\n  font-family: 'Sofia Pro';\n  padding-left: 16px;\n  padding-top: 13px;\n  width: ", ";\n  :focus {\n    border: 1px solid ", ";\n  }\n\n  ::placeholder {\n    color: ", ";\n  }\n"]);

  _templateObject = function _templateObject() {
    return data;
  };

  return data;
}

function _taggedTemplateLiteral(strings, raw) { if (!raw) { raw = strings.slice(0); } return Object.freeze(Object.defineProperties(strings, { raw: { value: Object.freeze(raw) } })); }

var TextArea = _styledComponents["default"].textarea(_templateObject(), _TextInput.COLORS["default"], function (props) {
  return props.width ? "".concat(props.width, "px") : '100%';
}, _TextInput.COLORS.focused, _TextInput.COLORS["default"]);

exports.TextArea = TextArea;